<div class="layout-column custom-panel full-height" [ngClass]="{'assign': selectedTab === 'assignCalls'}">
  <form class="flex layout-column" #cellEditForm="ngForm" (ngSubmit)="onSubmit(cellEditForm)">
    <ng-container *ngIf="selectedTab !== 'assignCalls'">
      <div class="layout-row layout-align-start-center header">
        <span
          class="br-body-2 font-weight-600 primary-100">{{ visitPlanCell.calls?.length || 0 }} {{ 'Calls' |translate }} </span>
        <span class="flex"></span>
        <ng-container *ngxPermissionsOnly="'schedulingProject.visitPlan.update'">
          <ng-container *ngIf="selectedTab !== 'deliveryEdit'">
            <bringoz-button
              *ngIf="selectedTab === 'callsList' && !getFieldValue(visitPlanCell.deliveryDetails.isDeliveryDay)"
              type="tertiary"
              [isDisabled]="isDayDispatched"
              [ngbTooltip]="blockedActionTooltipKey | translate"
              container="body"
              openDelay="300"
              (onClick)="onAddDelivery()">
              <span class="br-body-1 font-weight-400 blue-104">Add a delivery</span>
            </bringoz-button>
            <bringoz-button
              *ngIf="selectedTab === 'callsList' && getFieldValue(visitPlanCell.deliveryDetails.isDeliveryDay)"
              type="tertiary"
              [isDisabled]="isDayDispatched"
              [ngbTooltip]="blockedActionTooltipKey | translate"
              container="body"
              openDelay="300"
              (onClick)="onRemoveDelivery()">
              <span class="br-body-1 font-weight-400 blue-104">Remove delivery</span>
            </bringoz-button>
            <bringoz-button *ngIf="selectedTab === 'callsList'"
                            type="tertiary"
                            [isDisabled]="isDayDispatched"
                            [ngbTooltip]="blockedActionTooltipKey | translate"
                            container="body"
                            openDelay="300"
                            (onClick)="onAddCall()">
              <span class="br-body-1 font-weight-400 blue-104">Add a call</span>
            </bringoz-button>
          </ng-container>
        </ng-container>
        <bringoz-button type="tertiary"
                        (onClick)="onClose.emit()">
          <bringoz-icon iconName="close"></bringoz-icon>
        </bringoz-button>
      </div>
      <hr class="main-divider">
    </ng-container>
    <div class="layout-column flex overflow-auto">
      <div *ngIf="selectedTab === 'callsList'" class="flex layout-column padding-10">
        <div class="layout-row layout-align-start-center gap-5"
             *ngFor="let call of visitPlanCell.calls"
             [ngClass]="{'locked-row': call.locked}">

          <app-bringoz-checkbox class="margin-right-5"
                                [isChecked]="selectedCallsMap[call.id]"
                                (clickEvent)="onSelectCall(call.id)">
          </app-bringoz-checkbox>

          <span class="call"
                [ngClass]="{'Routed': (visitPlan.scheduleStatus === 'PLANNED' && callAnalysisMap[call.id]?.routed), 'Leftover': (visitPlan.scheduleStatus === 'PLANNED' && !callAnalysisMap[call.id]?.routed), 'Risk': !!callAnalysisMap[call.id]?.risks && !!callAnalysisMap[call.id].risks.length}">
            {{ programTypeAliasMap[$any(getFieldValue(call.programType))] }}
          </span>

          <div class=" layout-row flex text-ellipsis gap-5">
<!--            <div *ngIf="call.destination" class="br-body-1 font-weight-400">-->
<!--              <span *ngIf="call.destination?.notAfter?.adjusted">-->
<!--                {{call.destination.notBefore.adjusted | bringozTime: 'value'}} - {{call.destination.notAfter.adjusted | bringozTime: 'value'}}-->
<!--              </span>-->
<!--              <span *ngIf="!call.destination?.notAfter?.adjusted">-->
<!--                {{call.destination.notBefore.initial | bringozTime: 'value'}} - {{call.destination.notAfter.initial | bringozTime: 'value'}}-->
<!--              </span>-->
<!--&lt;!&ndash;              {{ call.destination?.notAfter?.adjusted ? ({notBefore: call.destination.notBefore.adjusted.value, notAfter: call.destination.notAfter.adjusted.value} | timeWindow) :  ({notBefore: call.destination.notBefore.initial.value, notAfter: call.destination.notAfter.initial.value} | timeWindow)}}&ndash;&gt;-->
<!--            </div>-->

            <span *ngIf="!call.destination?.serviceTime?.adjusted?.value" class="br-body-1 font-weight-400">
              {{ call.destination?.serviceTime?.initial?.value?.generatedTotalTime | bringozTimeConvert: true }}
            </span>
            <span *ngIf="!!call.destination?.serviceTime?.adjusted?.value" class="br-body-1 font-weight-400">
              {{ call.destination?.serviceTime?.adjusted?.value?.generatedTotalTime | bringozTimeConvert: true }}
            </span>
          </div>

          <span class="br-body-2" *ngIf="callAnalysisMap[call.id]?.routed">
            {{callAnalysisMap[call.id]?.agentName}}
          </span>

          <ng-container *ngxPermissionsOnly="'schedulingProject.visitPlan.update'">
            <bringoz-button *ngIf="callAnalysisMap[call.id]?.routed"
                            type="tertiary"
                            [isDisabled]="isDayDispatched"
                            [ngbTooltip]="isDayDispatched ? (blockedActionTooltipKey | translate) : ((call.locked ? 'Unlock' : 'Lock') | translate)"
                            container="body"
                            openDelay="300"
                            (onClick)="onToggleLockCall(call); $event.stopPropagation()">
              <bringoz-icon [iconName]="call.locked ? 'lock' : 'lock-open-outline'" classSize="md"></bringoz-icon>
            </bringoz-button>
          </ng-container>

          <ng-container *ngxPermissionsOnly="'schedulingProject.visitPlan.update'">
            <bringoz-button type="tertiary"
                            [isDisabled]="isDayDispatched"
                            [ngbTooltip]="blockedActionTooltipKey | translate"
                            container="body"
                            openDelay="300"
                            (onClick)="onEditCall(call)">
              <bringoz-icon iconName="edit-outline"></bringoz-icon>
            </bringoz-button>
            <bringoz-button type="tertiary"
                            [isDisabled]="call.locked || isDayDispatched"
                            [ngbTooltip]="blockedActionTooltipKey | translate"
                            container="body"
                            openDelay="300"
                            (onClick)="onDeleteCall(call.id)">
              <bringoz-icon iconName="trash" fill="#F44336"></bringoz-icon>
            </bringoz-button>
          </ng-container>
        </div>
      </div>

      <div *ngIf="selectedTab === 'callEdit'" class="flex layout-column padding-10">
        <!--        <div>-->
        <!--          <label translate>Units Count</label>-->
        <!--          <input type="text"-->
        <!--                 name="units"-->
        <!--                 class="form-control input"-->
        <!--                 [(ngModel)]="currentEditingCallModel.units"-->
        <!--                 #units="ngModel"-->
        <!--                 required>-->
        <!--          <div class="br-caption-1 red-103 margin-top-5" *ngIf="units.invalid && units.touched">-->
        <!--            This field is required-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="total-service-time br-caption-2 font-weight-400 layout-row layout-align-start-center">
          <span translate>Current total service time</span>:
          <!--          <app-task-detailed-service-time class="margin-left-5"-->
          <!--                                          [detailedServiceTime]="currentEditingCallModel.serviceTime">-->
          <!--          </app-task-detailed-service-time>-->

          <span
            class="font-weight-400 margin-left-5">{{ (currentEditingCallModel.serviceTime.generatedTotalTime || 0)| serviceTime }}
          </span>

          <bringoz-icon iconName="info-outline"
                        class="margin-left-5 gray-103"
                        [ngbTooltip]="tooltipTmpl"
                        openDelay="300"
                        triggers="hover"
                        container="body"></bringoz-icon>

          <ng-template #tooltipTmpl>
            <div class="layout-column">
              <div class="layout-row layout-align-start-center margin-bottom-5">
                <span class="br-body-1 font-weight-400 gray-101">{{ 'Work Service Time' | translate }}:</span>
                <span
                  class="br-body-1 font-weight-400 margin-left-5 gray-101">{{ currentEditingCallModel.serviceTime.workTime | serviceTime }}</span>
              </div>
              <div class="layout-row layout-align-start-center margin-bottom-5">
                <span class="br-body-1 font-weight-400 gray-101">{{ 'Subtasks Service Time' | translate }}:</span>
                <span
                  class="br-body-1 font-weight-400 margin-left-5 gray-101">{{ currentEditingCallModel.serviceTime.subTasksTime | serviceTime }}</span>
              </div>
              <div class="layout-row layout-align-start-center margin-bottom-5">
                <span class="br-body-1 font-weight-400 gray-101">{{ 'Entry Service Time' | translate }}:</span>
                <span
                  class="br-body-1 font-weight-400 margin-left-5 gray-101">{{ currentEditingCallModel.serviceTime.entryTime | serviceTime }}</span>
              </div>
              <div class="layout-row layout-align-start-center margin-bottom-5">
                <span class="br-body-1 font-weight-400 gray-101">{{ 'Exit Service Time' | translate }}:</span>
                <span
                  class="br-body-1 font-weight-400 margin-left-5 gray-101">{{ currentEditingCallModel.serviceTime.exitTime | serviceTime }}</span>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="margin-top-10">
          <label translate>Work Service Time</label>
          <div class="service-time-container">
            <div class="service-time-input layout-row layout-align-start-center gap-5">
              <app-bringoz-duration-mins-hours-input class="flex"
                                                     [(valueMs)]="currentEditingCallModel.serviceTime.workTime"
                                                     [disabled]="!!isOrderOrSell"
                                                     hoursTestId="visit-plan-cell-dialog-call-hours"
                                                     minutesTestId="visit-plan-cell-dialog-call-minutes">

              </app-bringoz-duration-mins-hours-input>

              <ng-container *ngIf="!isServiceTimeFromMLPrediction && !isOrderOrSell">
                <bringoz-button type="outline"
                                theme="secondary"
                                size="sm"
                                class="margin-top-15"
                                appBringozIdGenerator="visit-plan-cell-dialog-call-suggestion"
                                [ngbPopover]="popContent"
                                #predictionPopover="ngbPopover"
                                placement="top"
                                container="body"
                                triggers="click"
                                [autoClose]="true"
                                (onClick)="getPredictions(predictionPopover.isOpen())">
                  <bringoz-icon iconName="star-blue"></bringoz-icon>
                </bringoz-button>
              </ng-container>

              <ng-template #popContent>
                <div class="flex layout-column ml-service-time-popover">
                  <div class="flex layout-column">
                    <span translate>Suggested service time:</span>
                    <div class="flex flex-row">
                      <ng-container *ngIf="!isLoading && mlServiceTimeSuggestion$ | async as ml">
                        <span class="ml-suggested-time-text">{{ formatMinutesToHHMM(calcServiceTimeFromHoursToMinutes(ml)) }}</span>
                        <span translate> (based on past data)</span>
                      </ng-container>
                      <ng-container *ngIf="isLoading || !(mlServiceTimeSuggestion$ | async)">
                        <span class="ml-suggested-time-text">Calculating...</span>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="!isLoading && mlServiceTimeSuggestion$ | async as ml"
                       class="flex layout-row space-between gap-10 margin-top-10">
                    <bringoz-button size="sm" type="outline"
                                    appBringozIdGenerator="visit-plan-cell-dialog-call-suggestion-discard"
                                    [isDisabled]="!ml"
                                    (click)="closeMlServiceTimeMenu()">
                      <bringoz-icon iconName="close"></bringoz-icon>
                      <span translate>Discard</span>
                    </bringoz-button>

                    <ng-container *ngIf="{ml: mlServiceTimeSuggestion$ | async} as data">
                      <bringoz-button size="sm" type="outline"
                                      appBringozIdGenerator="visit-plan-cell-dialog-call-suggestion-accept"
                                      [isDisabled]="!ml"
                                      (click)="updateServiceTimeFromMlSuggestion(data.ml ?? currentEditingCallModel.serviceTime.workTime)">
                        <bringoz-icon iconName="check"></bringoz-icon>
                        <span translate>Accept</span>
                      </bringoz-button>
                    </ng-container>
                  </div>
                </div>
              </ng-template>

            </div>
          </div>
        </div>

        <!-- Service time prediction if computed not from ML config -->
<!--        <ng-container *ngIf="!isServiceTimeFromMLPrediction">-->
<!--          <app-service-time-prediction-input-->
<!--            [serviceWorkTime]="currentEditingCallModel.serviceTime.workTime"-->
<!--            (applyMLServiceTime)="updateServiceTimeWithMlTime($event)">-->

<!--          </app-service-time-prediction-input>-->
<!--        </ng-container>-->

      </div>

      <div *ngIf="selectedTab === 'moveDay'" class="flex layout-column padding-10">
        <div *ngFor="let day of moveDayOptions"
             class="move-day-option layout-row layout-align-start-center margin-bottom-10"
             [ngbTooltip]="day.isDispatched ? ('VISIT_SCHEDULE_TOOLTIPS.DAY_BLOCKED_DISPATCHED' | translate) : ''"
             container="body"
             openDelay="300">
          <app-bringoz-radio-button
            [value]="day.timestamp"
            [isDisabled]="day.isDispatched"
            (onValueChange)="onChangeMoveDay($event)"
            [isSelected]="selectedMoveDayOption?.timestamp === day.timestamp">
          </app-bringoz-radio-button>
          <span class="br-body-2 font-weight-400 primary-100 margin-left-10">{{ day.dayName }} {{ day.date }}</span>
        </div>
      </div>

      <div *ngIf="selectedTab === 'assignCalls'" class="flex layout-column">
        <app-visit-plan-schedule-resource-select-list
          class="flex layout-column overflow-hidden"
          [visitPlan]="data.visitPlan"
          [callIds]="selectedIds"
          [visitScheduleId]="data.visitPlan.scheduleId"
          [dateRange]="assignCallsDateRange"
          [agentIds]="[]"
          [showFooter]="false"
          [selectedResourceId]="selectedResourceId"
          (onResourceSelected)="onSelectResource($event)"
          (onExternalResourceSelected)="onExternalResourceSelected($event)">
        </app-visit-plan-schedule-resource-select-list>
      </div>

      <div *ngIf="selectedTab === 'deliveryEdit'" class="flex layout-column padding-10">
        <div>
          <label translate>Units Count</label>
          <input type="text"
                 name="deliveryUnits"
                 class="form-control input"
                 [(ngModel)]="deliveryUnits"
                 #units="ngModel"
                 required>
          <div class="br-caption-1 red-103 margin-top-5" *ngIf="units.invalid && units.touched">
            This field is required
          </div>
        </div>
      </div>

    </div>

    <ng-container *ngxPermissionsOnly="'schedulingProject.visitPlan.update'">
      <div *ngIf="selectedTab === 'callsList' && !!visitPlanCell.calls?.length" class="layout-column">
        <hr class="main-divider">
        <div class="layout-row layout-align-start-center padding-10">
          <bringoz-button *ngIf="!this.data.visitPlanCellTracker"
                          type="tertiary"
                          [isDisabled]="!selectedIds.length || hasSelectedLockedCall || isDayDispatched"
                          [ngbTooltip]="blockedActionTooltipKey | translate"
                          container="body"
                          openDelay="300"
                          (onClick)="onMoveDay()">
            <span class="br-body-1 font-weight-400 blue-104">Move Day</span>
          </bringoz-button>

          <bringoz-button *ngIf="visitPlan.scheduleStatus === 'PLANNED' && !this.data.visitPlanCellTracker"
                          type="tertiary"
                          [isDisabled]="!selectedIds.length || hasSelectedLockedCall || visitPlan?.hasNotSyncedChanges || isDayDispatched"
                          [ngbTooltip]="blockedActionTooltipKey | translate"
                          container="body"
                          openDelay="300"
                          (onClick)="onAssignCalls()">
            <span class="br-body-1 font-weight-400 blue-104" translate>Assign</span>
          </bringoz-button>

          <bringoz-button *ngIf="!!enableUnassignedAction && visitPlan.scheduleStatus === 'PLANNED' && !this.data.visitPlanCellTracker"
                          type="tertiary"
                          [isDisabled]="!selectedIds.length || hasSelectedLockedCall || visitPlan?.hasNotSyncedChanges || isDayDispatched"
                          [ngbTooltip]="blockedActionTooltipKey | translate"
                          container="body"
                          openDelay="300"
                          (onClick)="onUnAssignCalls()">
            <span class="br-body-1 font-weight-400 blue-104" translate>Unassign</span>
          </bringoz-button>

          <span class="flex"></span>

          <bringoz-button type="tertiary"
                          [isDisabled]="!selectedIds.length || isDayDispatched"
                          [ngbTooltip]="blockedActionTooltipKey | translate"
                          container="body"
                          openDelay="300"
                          (onClick)="onDeleteCalls()">
            <span class="br-body-1 font-weight-400 red-103" translate>Delete Calls</span>
          </bringoz-button>
        </div>
      </div>
    </ng-container>


    <div *ngIf="selectedTab === 'callEdit' || selectedTab === 'moveDay' || selectedTab === 'deliveryEdit' || selectedTab === 'assignCalls'"
         class="layout-column">
      <hr class="main-divider">
      <div class="layout-row layout-align-start-center padding-10">
        <bringoz-button type="tertiary"
                        (onClick)="onCancelCallEdit()">
          <span class="br-body-1 font-weight-400 gray-101">Back</span>
        </bringoz-button>

        <span class="flex"></span>

        <bringoz-button *ngIf="selectedTab === 'callEdit' && !data.initialEditCallId" type="tertiary"
                        appBringozIdGenerator="visit-plan-cell-dialog-call-advanced"
                        (onClick)="onAdvancedEdit()">
          <span class="br-body-1 font-weight-400 blue-104">Advanced</span>
        </bringoz-button>

        <bringoz-button type="tertiary"
                        [appBringozIdGenerator]="selectedTab === 'callEdit' ? 'visit-plan-cell-dialog-call-submit' : 'submitEditCall'"
                        [isDisabled]="isFormDisabled || isAssigningCalls"
                        buttonType="submit">
          <span class="br-body-1 font-weight-400 blue-104">{{ isAssigningCalls ? ('Assigning...' | translate) : ('Submit' | translate) }}</span>
        </bringoz-button>
      </div>
    </div>
  </form>
</div>
